"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePickerContent = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FilePicker_constants_1 = require("../FilePicker.constants");

var CloseIcon_1 = require("./CloseIcon");

var FilePicker_dropzone_1 = require("./FilePicker.dropzone");

var FilePicker_filePreview_1 = require("./FilePicker.filePreview");

var FilePicker_styles_1 = require("./FilePicker.styles");

var shouldShowUploadMoreBtn = function shouldShowUploadMoreBtn(options, length) {
  if (options && options.maxFiles) {
    return length < options.maxFiles;
  }

  return true;
};

var shouldShowUploadBtn = function shouldShowUploadBtn(options, length) {
  if (options && options.minFiles) {
    return length >= options.minFiles;
  }

  return true;
};

var FilePickerContent = function FilePickerContent(_ref) {
  var step = _ref.step,
      hideFilePicker = _ref.hideFilePicker,
      fileList = _ref.fileList,
      setUploadStep = _ref.setUploadStep,
      removeFile = _ref.removeFile,
      setUploadMoreStep = _ref.setUploadMoreStep,
      upload = _ref.upload,
      fileProgressList = _ref.fileProgressList,
      getRootProps = _ref.getRootProps,
      getInputProps = _ref.getInputProps,
      options = _ref.options,
      errorMessage = _ref.errorMessage;
  var shouldShowError = errorMessage; //console.log(shouldShowError);
  //console.log(step);

  switch (step) {
    case FilePicker_constants_1.STEPS.select:
      {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.header
        }, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.closeWrapper,
          onClick: hideFilePicker
        }, react_1.default.createElement(CloseIcon_1.CloseIcon, null))), react_1.default.createElement(FilePicker_dropzone_1.FilePickerDropZone, {
          getRootProps: getRootProps,
          getInputProps: getInputProps
        }), shouldShowError && react_1.default.createElement("div", {
          className: FilePicker_styles_1.ERROR_STYLES
        }, errorMessage));
      }

    case FilePicker_constants_1.STEPS.uploadMore:
      {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.header
        }, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.closeWrapper,
          onClick: hideFilePicker
        }, react_1.default.createElement(CloseIcon_1.CloseIcon, null))), react_1.default.createElement(FilePicker_dropzone_1.FilePickerDropZone, {
          getRootProps: getRootProps,
          getInputProps: getInputProps
        }), react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.footer
        }, react_1.default.createElement("span", {
          className: FilePicker_styles_1.CONTENT_STYLES.footerDetails
        }, "Selected Files: ", fileList.length), react_1.default.createElement("button", {
          className: FilePicker_styles_1.COMMON_STYLES.button,
          onClick: setUploadStep
        }, "View Selected")));
      }

    case FilePicker_constants_1.STEPS.upload:
      {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.header
        }, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.headerTitle
        }, "Selected Files"), react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.closeWrapper,
          onClick: hideFilePicker
        }, react_1.default.createElement(CloseIcon_1.CloseIcon, null))), react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.listWrapper
        }, fileList.map(function (el, index) {
          return react_1.default.createElement(FilePicker_filePreview_1.FilePreview, {
            key: "".concat(el.name, "_").concat(index),
            size: el.size,
            name: el.name,
            src: el.localPath,
            onRemoveClick: removeFile(el)
          });
        })), react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.footer
        }, shouldShowUploadMoreBtn(options, fileList.length) && react_1.default.createElement("button", {
          className: FilePicker_styles_1.COMMON_STYLES.button,
          onClick: setUploadMoreStep
        }, "Upload more"), shouldShowUploadBtn(options, fileList.length) && react_1.default.createElement("button", {
          className: FilePicker_styles_1.COMMON_STYLES.button,
          onClick: upload
        }, "Upload")));
      }

    case FilePicker_constants_1.STEPS.uploading:
      {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.header
        }, react_1.default.createElement("span", {
          className: FilePicker_styles_1.CONTENT_STYLES.headerTitle
        }, "Selected Files")), react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.listWrapper
        }, fileList.map(function (el, index) {
          return react_1.default.createElement(FilePicker_filePreview_1.FilePreview, {
            key: "".concat(el.name, "_").concat(index),
            size: el.size,
            name: el.name,
            src: el.localPath,
            isUploading: true,
            progress: fileProgressList[index]
          });
        })));
      }

    case FilePicker_constants_1.STEPS.error:
      {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.header
        }, react_1.default.createElement("div", {
          className: FilePicker_styles_1.CONTENT_STYLES.closeWrapper,
          onClick: hideFilePicker
        }, react_1.default.createElement(CloseIcon_1.CloseIcon, null))), react_1.default.createElement(FilePicker_dropzone_1.FilePickerDropZone, {
          getRootProps: getRootProps,
          getInputProps: getInputProps
        }), shouldShowError && react_1.default.createElement("div", {
          className: FilePicker_styles_1.ERROR_STYLES
        }, errorMessage));
      }

    default:
      {
        return null;
      }
  }
};

exports.FilePickerContent = FilePickerContent;